// Rúbricas oficiales del Portafolio Docente 2026
// Módulo 1: Planificación, Evaluación Formativa y Reflexión Pedagógica
// Fuente: Rúbricas oficiales CPEIP / DocenteMás 2026 (EM, PC y EB)
// Los resultados nacionales se importan de la FUENTE ÚNICA: resultados-nacionales.js

import { RESULTADOS_NACIONALES } from './resultados-nacionales';

// Helper to inject national results into each rubric
function withResultados(rubrica) {
    const data = RESULTADOS_NACIONALES[rubrica.indicadorId];
    if (data) {
        rubrica.resultadosNacionales = {
            destacado: data.destacado,
            competente: data.competente,
            basico: data.basico,
            insatisfactorio: data.insatisfactorio,
            totalDocentes: data.totalDocentes,
            lecturaSistema: data.lecturaSistema,
            dificultad: data.dificultad,
            implicancia: data.implicancia,
        };
    }
    return rubrica;
}

export const RUBRICAS_OFICIALES = [
    {
        id: 'rubrica-1-1',
        tarea: 'tarea-1',
        tareaLabel: 'Tarea 1',
        indicadorId: 'indicador-1-1',
        indicadorNum: 1,
        nombre: 'Formulación de objetivos de aprendizaje',
        descripcion: 'Este indicador evalúa la capacidad de el/la docente para plantear objetivos de aprendizaje que indican claramente las habilidades y conocimientos que sus estudiantes deben desarrollar.',
        evidencia: 'Tarea 1 Planificación de la enseñanza para todos y todas los/as estudiantes. Tablas de descripción de las tres experiencias: solo objetivos de las experiencias de aprendizaje.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con la condición del nivel Básico.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'La mayoría de los objetivos propuestos para las experiencias dan cuenta claramente de las habilidades y conocimientos que el/la docente se propuso alcanzar con sus estudiantes.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Todos los objetivos propuestos para las experiencias dan cuenta claramente de las habilidades y conocimientos que el/la docente se propuso alcanzar con sus estudiantes.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'Logra integrar conocimientos, habilidades y actitudes en objetivos propuestos para sus experiencias.',
                ],
            },
        },
        notas: [
            '¿Cuándo un objetivo NO da cuenta claramente de lo que el/la docente se propone alcanzar con sus estudiantes?',
            'Cuando está redactado como un objetivo a realizar por el/la docente (Ej. Revisar los avances de los trabajos por cada estudiante).',
            'Cuando su redacción involucra demasiadas habilidades y/o conocimientos, de modo que no se entiende realmente lo que el/la docente apunta alcanzar con sus estudiantes.',
            'Cuando señala solo la actividad y no el aprendizaje que se quiere lograr a través de ella.',
            'En el caso de los objetivos centrados exclusivamente en aspectos actitudinales o transversales, dada su naturaleza, no es necesario que incluyan habilidad y conocimiento. Este tipo de objetivos deben incluir claramente la actitud que deben desarrollar los/as estudiantes y en relación con qué deben desarrollar dicha actitud.',
        ],
    },
    {
        id: 'rubrica-1-2',
        tarea: 'tarea-1',
        tareaLabel: 'Tarea 1',
        indicadorId: 'indicador-1-2',
        indicadorNum: 2,
        nombre: 'Relación entre actividades y objetivos',
        descripcion: 'Este indicador evalúa la capacidad de el/la docente para proponer actividades coherentes con los objetivos de aprendizaje.',
        evidencia: 'Tarea 1 Planificación de la enseñanza para todos/as sus estudiantes. Tablas de descripción de las tres experiencias de aprendizaje con sus respectivos objetivos.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con la condición del nivel Básico.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'En la mayoría de las experiencias: todos los objetivos de la experiencia son abordados a través de actividades que el/la docente propone a sus estudiantes, y todas las actividades se relacionan con los objetivos.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'En todas las experiencias: todos los objetivos de la experiencia son abordados a través de actividades que el/la docente propone a sus estudiantes, y todas las actividades se relacionan con los objetivos.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'En alguna de las experiencias de aprendizaje, el/la docente propone al menos una actividad contextualizada que permite a los/as estudiantes comprender el sentido, importancia o utilidad de los aprendizajes propuestos.',
                ],
            },
        },
        notas: [
            'Las actividades en el contexto pedagógico contemplan todas las propuestas que hace el/la docente a sus estudiantes para que ellos/as alcancen los aprendizajes, por ejemplo: las tareas que les solicita, las preguntas que les formula, las actividades grupales e individuales, las explicaciones, recursos, etc.',
            'Actividades contextualizadas: son aquellas que permiten a los/as estudiantes transferir lo que van aprendiendo a situaciones o problemas reales, fuera del ámbito netamente teórico, ya sean conocidas o con las que ya están familiarizados/as, como también situaciones o problemas nuevos.',
        ],
    },
    {
        id: 'rubrica-1-3',
        tarea: 'tarea-1',
        tareaLabel: 'Tarea 1',
        indicadorId: 'indicador-1-3',
        indicadorNum: 3,
        nombre: 'Fundamentación de la planificación de una experiencia de aprendizaje',
        descripcion: 'Este indicador evalúa la capacidad de el/la docente para fundamentar la pertinencia de las estrategias de enseñanza con la diversidad de su grupo, considerando distintos tipos de características de los/as estudiantes y los aprendizajes propuestos.',
        evidencia: 'Tarea 1 Planificación de la enseñanza para todos y todas los/as estudiantes: Subtarea 1.A Tablas de descripción de las tres experiencias de aprendizaje. Subtarea 1.B. Fundamentación de la planificación de una experiencia de aprendizaje.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con las condiciones del nivel Básico.',
                    'La respuesta o fundamentación no hace referencia a las experiencias de aprendizaje presentadas en la tarea 1.A.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'El/la docente fundamenta la pertinencia de la experiencia de aprendizaje planificada, vinculando, al menos, una oportunidad de aprendizaje con una característica de sus estudiantes.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'El/la docente fundamenta la pertinencia de la experiencia de aprendizaje planificada, vinculando:',
                    'Las variadas oportunidades que ofrece a sus estudiantes para que puedan participar y avanzar en el aprendizaje propuesto con',
                    'Las diferencias que existen entre sus estudiantes, refiriendo al menos a dos de los siguientes tipos de características: de aprendizaje, del contexto sociocultural y otras asociadas a sus experiencias e intereses.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'En su fundamentación el/la docente explica cómo en la experiencia promueve que los/as estudiantes respeten o valoren la diversidad.',
                    'En su fundamentación el/la docente logra reflexionar sobre su propia práctica, en relación con el enfoque inclusivo.',
                ],
            },
        },
        notas: [
            'Variedad de oportunidades: se observan en el diseño de estrategias de aprendizaje, a través de múltiples y diversas acciones para generar aprendizajes y lograr un desarrollo integral de todos los y las estudiantes.',
            'Características de aprendizaje: conocimientos previos, trayectorias educativas, habilidades propias del nivel, ritmos y formas de aprendizaje, entre otras.',
            'Características del contexto sociocultural: etnia, nacionalidad, características de la comunidad educativa, de las familias y comunidad local en que se insertan, entre otras.',
            'Características asociadas a sus experiencias e intereses: gustos, preferencias, aficiones, historias de vida, rango etario, identidad de género, entre otras.',
            'La reflexión es entendida como la indagación y análisis de las situaciones de la práctica que implican pensar detenidamente sobre los elementos significativos de esta, evaluando y cuestionando la propia práctica.',
        ],
    },
    {
        id: 'rubrica-2-1',
        tarea: 'tarea-2',
        tareaLabel: 'Tarea 2',
        indicadorId: 'indicador-2-1',
        indicadorNum: 4,
        nombre: 'Estrategia de monitoreo de los aprendizajes',
        descripcion: 'Este indicador evalúa la capacidad de el/la docente para plantear indicadores de evaluación que señalan el desempeño esperado e implementar una actividad coherente con esos indicadores, con el fin de monitorear el progreso de los/as estudiantes en los aprendizajes.',
        evidencia: 'Tarea 2 Evaluación formativa. 2.A Estrategia de monitoreo del aprendizaje.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con la condición del nivel Básico.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'Al menos la mitad de los indicadores de evaluación dan cuenta de conductas observables, relacionadas con el(los) Objetivo(s) de Aprendizaje que se propuso abordar.',
                    'Y la actividad implementada para monitorear permite recoger evidencia de al menos la mitad de los indicadores de evaluación que contempló.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'Todos los indicadores de evaluación dan cuenta de conductas observables, relacionadas con el(los) Objetivo(s) de Aprendizaje que se propuso abordar.',
                    'Y la actividad implementada para monitorear permite recoger evidencia de todos los indicadores de evaluación que contempló.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'En la estrategia de monitoreo el/la docente ofrece distintas formas o alternativas para que los/as estudiantes puedan demostrar sus aprendizajes.',
                ],
            },
        },
        notas: [
            'Los indicadores de evaluación se caracterizan por detallar los desempeños o conductas específicas que espera observar y evaluar usando una determinada estrategia. También por considerar habilidad y contenido, ser acotados y estar redactados de manera simple y breve.',
            'La actividad que describa debe referir directamente a lo que espera monitorear. Sea detallado/a al referirse a esta actividad, pues respuestas generales tales como "hice preguntas" o "hicieron la guía" sin indicar en qué consistían, no permiten saber si a partir de la misma es posible levantar información sobre los indicadores monitoreados.',
        ],
    },
    {
        id: 'rubrica-2-2',
        tarea: 'tarea-2',
        tareaLabel: 'Tarea 2',
        indicadorId: 'indicador-2-2',
        indicadorNum: 5,
        nombre: 'Análisis a partir del monitoreo de los aprendizajes',
        descripcion: 'Este indicador evalúa la capacidad de el/la docente para analizar e interpretar la información recogida a través de las estrategias de monitoreo, identificando sus causas y estableciendo conclusiones relevantes para su trabajo pedagógico.',
        evidencia: 'Tarea 2 Evaluación formativa. 2.B Análisis y uso formativo de la evaluación. 2.B.a Analice los resultados de aprendizajes que pudo levantar a partir de la estrategia de monitoreo implementada y explique qué conclusiones pudo extraer respecto de los mismos. 2.B.b ¿Cuáles son las posibles causas de estos resultados?',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con la condición del nivel Básico.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'El/la docente analiza distintos resultados de aprendizaje que observa durante el monitoreo, es decir, da cuenta de aspectos logrados, no logrados y/o diferencias entre los desempeños de sus estudiantes.',
                    'Y menciona las posibles causas sin explicar cómo sus decisiones pedagógicas o situaciones contextuales favorecieron o dificultaron al menos un resultado de aprendizaje observado.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'El/la docente analiza distintos resultados de aprendizaje que observa durante el monitoreo, es decir, da cuenta de aspectos logrados, no logrados y/o diferencias entre los desempeños de sus estudiantes.',
                    'Y explica las posibles causas, es decir, por qué sus decisiones pedagógicas o situaciones contextuales favorecieron o dificultaron al menos un resultado de aprendizaje observado.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'Explica los resultados de aprendizaje observados en sus estudiantes considerando causas de distinta naturaleza: tanto sus decisiones pedagógicas como situaciones contextuales.',
                ],
            },
        },
        notas: [],
    },
    {
        id: 'rubrica-2-3',
        tarea: 'tarea-2',
        tareaLabel: 'Tarea 2',
        indicadorId: 'indicador-2-3',
        indicadorNum: 6,
        nombre: 'Uso formativo de la información recogida a partir del monitoreo',
        descripcion: 'Este indicador evalúa la capacidad de el/la docente para ajustar o plantear estrategias orientadas a la mejora de los aprendizajes de sus estudiantes, a partir de la información recogida durante el monitoreo de los aprendizajes.',
        evidencia: 'Tarea 2 Evaluación formativa. 2.B Análisis y uso formativo de la evaluación. 2.B.c Teniendo en cuenta el análisis de los resultados y las causas identificadas, describa detalladamente las acciones que realizó para favorecer el logro de los aprendizajes de los/as estudiantes.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con la condición del nivel Básico.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'El/la docente propone al menos una acción orientada a mejorar los aprendizajes observados.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'El/la docente propone al menos dos acciones orientadas a mejorar los aprendizajes observados, y al menos una de ellas promueve que los/as estudiantes se involucren en la mejora de sus aprendizajes.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'Propone acciones que se hacen cargo tanto de quienes tienen dificultades como de quienes han logrado los aprendizajes.',
                ],
            },
        },
        notas: [],
    },
    {
        id: 'rubrica-3-1',
        tarea: 'tarea-3',
        tareaLabel: 'Tarea 3',
        indicadorId: 'indicador-3-1',
        indicadorNum: 7,
        nombre: 'Reflexión en torno al desarrollo de aprendizajes socioemocionales',
        descripcion: 'Este indicador evalúa la capacidad de el/la docente para:\n\u2022 Reconocer el aprendizaje socioemocional que sus estudiantes necesitan desarrollar a partir de la observación de ellos/as en situaciones de la vida escolar.\n\u2022 Reflexionar sobre cómo sus actitudes, formas de actuar y de relacionarse con sus estudiantes favorece o dificulta promover el desarrollo de aprendizajes socioemocionales en ellos/as.',
        evidencia: 'Tarea 3 Reflexión en torno al desarrollo de aprendizajes socioemocionales.',
        niveles: {
            insatisfactorio: {
                label: 'Insatisfactorio',
                criterios: [
                    'No cumple con las condiciones del nivel Básico.',
                ],
            },
            basico: {
                label: 'Básico',
                criterios: [
                    'El/la docente identifica cuál es el aprendizaje socioemocional y, si bien, refiere al comportamiento que observó en sus estudiantes, no lo utiliza para fundamentar por qué necesitan desarrollar ese aprendizaje.',
                    'E identifica qué mantendría o qué modificaría de su actitud, forma de actuar o de relacionarse, solo mencionando en qué podría aportar al desarrollo del aprendizaje socioemocional, sin explicar cómo.',
                ],
            },
            competente: {
                label: 'Competente',
                criterios: [
                    'El/la docente identifica cuál es el aprendizaje socioemocional y fundamenta por qué sus estudiantes lo necesitan desarrollar, a partir del comportamiento que observó en sus estudiantes.',
                    'E identifica qué mantendría o qué modificaría de su actitud, forma de actuar o de relacionarse, explicando cómo esto podría aportar al desarrollo del aprendizaje socioemocional.',
                ],
            },
            destacado: {
                label: 'Destacado',
                criterios: [
                    'Cumple con el nivel Competente y, además:',
                    'A partir de la observación de los y las estudiantes, el/la docente relaciona distintos factores que pueden estar influyendo en su comportamiento y plantea hipótesis sobre lo que podrían estar pensando y sintiendo.',
                ],
            },
        },
        notas: [
            'Aprendizaje socioemocional: son conocimientos, habilidades y actitudes tanto sociales como emocionales relacionadas con el reconocimiento y manejo de emociones, con el cuidado y preocupación por otros y con la toma de decisiones responsables, entre otros.',
            'En esta explicación el/la docente debe entregar detalles de cómo lo que mantendría o modificaría (su actitud, forma de actuar o de relacionarse) influye en los/as estudiantes, es decir, cómo los/as hace sentir, cómo reaccionan a esto, cómo se va modificando su relación con ellos/as.',
            'Algunos factores que el/la docente puede relacionar son: características de sus estudiantes, de su contexto, formas de relacionarse entre los/as estudiantes o con los adultos, actitudes y formas de actuar, entre otros.',
        ],
    },
].map(withResultados);

// ⚠️ INDICADOR ELIMINADO en las rúbricas oficiales 2026 (CPEIP / DocenteMás).
// Se elimina del flujo activo (borradores, IA, diagnóstico, estrategias).
// No exportar.

// Group rubrics by task
export const RUBRICAS_POR_TAREA = {
    'tarea-1': RUBRICAS_OFICIALES.filter((r) => r.tarea === 'tarea-1'),
    'tarea-2': RUBRICAS_OFICIALES.filter((r) => r.tarea === 'tarea-2'),
    'tarea-3': RUBRICAS_OFICIALES.filter((r) => r.tarea === 'tarea-3'),
};
